import React from 'react';
import { View, Text, Platform, StyleSheet } from 'react-native';

export interface BarItem {
  label: string;
  value: number;
  color?: string;
}

interface Props {
  data: BarItem[];
  barColor?: string;
  height?: number;
  showValues?: boolean;
}

export default function MiniBarChart({ data, barColor = '#1C60A5', height = 70, showValues = true }: Props) {
  if (!data.length) return null;

  if (Platform.OS !== 'web') {
    return (
      <View style={styles.fallback}>
        <Text style={styles.fallbackText}>{data.map(d => `${d.label}:${d.value}`).join('  ')}</Text>
      </View>
    );
  }

  const max = Math.max(...data.map(d => d.value), 1);
  const BAR_W = 22;
  const GAP   = 6;
  const LABEL_H = 14;
  const VALUE_H = showValues ? 14 : 0;
  const svgH = height + LABEL_H + VALUE_H;
  const svgW = data.length * (BAR_W + GAP) - GAP + 8;

  return (
    <View>
      {/* @ts-ignore */}
      <svg width={svgW} height={svgH} viewBox={`0 0 ${svgW} ${svgH}`}>
        {data.map((d, i) => {
          const barH = Math.max(2, (d.value / max) * height);
          const x = 4 + i * (BAR_W + GAP);
          const y = height - barH;
          const color = d.color ?? barColor;
          const xC = x + BAR_W / 2;
          return (
            <g key={i}>
              {/* @ts-ignore */}
              <rect x={x} y={y} width={BAR_W} height={barH} fill={color} rx={3} opacity={0.85} />
              {showValues && d.value > 0 ? (
                // @ts-ignore
                <text x={xC} y={y - 2} textAnchor="middle" fontSize={8} fill="#555" fontWeight="600">
                  {d.value}
                </text>
              ) : null}
              {/* @ts-ignore */}
              <text x={xC} y={height + LABEL_H} textAnchor="middle" fontSize={8} fill="#999">{d.label}</text>
            </g>
          );
        })}
      </svg>
    </View>
  );
}

const styles = StyleSheet.create({
  fallback: { paddingVertical: 4 },
  fallbackText: { fontSize: 10, color: '#999' },
});
